import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTransition } from '../components/shared/PageTransition';
import { SEOHelmet } from '../components/seo/SEOHelmet';
import { HeroSection } from '../components/home/HeroSection';
import { FeaturesList } from '../components/home/FeaturesList';
import { CurrencyList } from '../components/home/CurrencyList';
import { ContactCTA } from '../components/home/ContactCTA';

export const Home: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageTransition>
      <SEOHelmet
        title={t('seo.home.title')}
        description={t('seo.home.description')}
        keywords="international banking, multicurrency accounts, SEPA payments, SWIFT transfers, business banking, global payments, currency exchange"
                canonical="https://gcbusiness.space/"
      />
      <HeroSection />
      <FeaturesList />
      <CurrencyList />
      <ContactCTA />
    </PageTransition>
  );
};
